import Button from '@jetbrains/ring-ui/components/button/button'
import {memo} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

import {useAppDispatch} from '../../../../../../hooks/react-redux'
import {getHrefWithQueryParams} from '../../../../../../routes'
import {pipelineDraft, pipelineYaml} from '../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../hooks/pipeline'
import {useSaveChangesState} from '../hooks/useSaveChangesState'

interface Props {
  className?: string
}
function CancelChangesButton(props: Props) {
  const {className} = props
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const pipelineId = usePipelineId()

  const {isLoading} = useSaveChangesState()
  const cancel = () => {
    dispatch(pipelineDraft.actions.reset(pipelineId))
    dispatch(pipelineYaml.actions.reset(pipelineId))
    navigate(getHrefWithQueryParams(location, null, {yaml: 'false'}), {replace: true})
  }

  return (
    <Button onClick={cancel} className={className} disabled={isLoading}>
      {'Cancel'}
    </Button>
  )
}

export default memo(CancelChangesButton)
